import { useState, useMemo } from "react";
import { useDebounce } from "@src/packages/hooks/useDebounce";
import type { ProviderFilters } from "../providers.types";

export function useProviderFilters(initial: ProviderFilters = {}) {
  const [filters, setFilters] = useState<ProviderFilters>(initial);

  const debouncedSearch = useDebounce(filters.search, 500);
  const filtersWithDebouncedSearch = useMemo(
    () => ({ ...filters, search: debouncedSearch }),
    [filters, debouncedSearch],
  );

  const updateFilters = (partial: Partial<ProviderFilters>) => {
    setFilters((prev) => ({ ...prev, ...partial }));
  };

  const replaceFilters = (next: ProviderFilters) => {
    setFilters(next);
  };

  return {
    filters,
    filtersWithDebouncedSearch,
    updateFilters,
    replaceFilters,
  };
}
